import { rm, combineReducers } from 'utils';
import { BaseAction, BaseInitialState, BaseState, baseFormReducer, baseReducer } from '../Utils';
import { isCustomerContactValid } from '../Components/CustomerContact/utils';

type InternalState = BaseState & {
  question: string;
  questionError?: string;
};

export const deliveriesInitialState: InternalState = {
  ...BaseInitialState,
  question: '',
  questionError: ''
};

type Action =
  | { type: 'question'; value: string }
  | { type: 'questionError'; value: string }
  | BaseAction;

export const deliveriesReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'question':
      return { ...state, question: action.value };
    case 'questionError':
      return { ...state, questionError: action.value };
    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  deliveriesReducer
);

export const isValid = (
  addressChanging: boolean,
  state: InternalState,
  dispatch: (action: Action) => void
) => {
  let isValid = true;

  if (addressChanging) {
    dispatch({
      type: 'addressError',
      value: rm('customerpage_returns_validation_error_address')
    });
    isValid = false;
  }

  if (state.question === '') {
    dispatch({
      type: 'questionError',
      value: rm('Customerpage_Deliveries_Question_Error')
    });
    isValid = false;
  }

  isValid = isCustomerContactValid({ state, valid: isValid, dispatch });

  return isValid;
};
